import { tokenPocket, tokenPocketDark } from "../../../utils";

export default {
  product: {
    title: '製品',
    label_1: 'KeyPal',
    label_2: 'Secret Box',
    label_3: 'レザーケース',
    label_4: 'すべてのアクセサリー',
    label_5: 'KeyPal カード',
  },
  upgrade: {
    label_1: 'アップグレード',
  },
  // learn タイトル下の説明
  learn: {
    label_1: 'あんぜん',
  },
  others: {
    label_1: '概要',
    label_2: 'プライバシーポリシー',
    label_3: '利用規約',
  },
  support: {
    title: 'サポート',
    label_1: 'ヘルプセンター',
    label_2: '購入に関するFAQ',
    label_3: 'コミュニティ',
  },
  cryptoAssets: {
    title: '暗号資産',
    label_1: 'ビットコインウォレット',
    label_2: 'イーサリアムウォレット',
    label_3: 'Solanaウォレット',
    label_4: 'Tronウォレット',
    label_5: 'ステーブルコインウォレット',
  }, 
  getStarted: {
    title: 'はじめに',
    label_1: 'ウォレットを安全に保つには？',
    label_2: 'KeyPal 2 の使い方',
    label_3: 'KeyPal Card の使い方',
    label_4: 'KeyPal Plus の使い方',
    label_5: 'Secret Box の使い方',
  }, 
  download: {
    title: 'ダウンロード',
    label_1: 'モバイルウォレット',
    label_2: '拡張機能ウォレット',
    label_3: 'アップグレード',
  }, 
  legal: {
    title: 'リーガル',
    label_1: 'プライバシーポリシー',
    label_2: '利用規約',
  }, 

  designed: `${tokenPocket} によってデザイン ❤️`,
  designedDark: `${tokenPocketDark} によってデザイン ❤️`,
}
